export default __webpack_public_path__ + "static/python-data-analytics-ecdaf129afaa0a1c8b1ac92fceede3b2.webp";